import React, { useState } from "react";
import "./ShareSquare.css";

function ShareSquare(props) {
  const [ShareSquare, setShareSquare] = useState(true);


  return (

        <img className="share_square_img box" src={props.shareData} alt="share"/>
  );
}
export default ShareSquare;
